(function () {
  function currentLabel(select) {
    const opt = select.options[select.selectedIndex];
    return opt ? opt.textContent.trim() : '';
  }

  function closeListbox(wrapper, trigger, listbox) {
    listbox.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    wrapper.classList.remove('is-open');
  }

  function openListbox(wrapper, trigger, listbox) {
    listbox.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    wrapper.classList.add('is-open');
  }

  function enhance(wrapper) {
    if (wrapper.dataset.customSelectEnhanced) return;

    const select = wrapper.querySelector('select.select__select');
    if (!select) return;

    wrapper.dataset.customSelectEnhanced = 'true';
    wrapper.classList.add('custom-select');
    select.classList.add('custom-select__native');

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'custom-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.textContent = currentLabel(select);

    const listbox = document.createElement('ul');
    listbox.className = 'custom-select__listbox';
    listbox.setAttribute('role', 'listbox');
    listbox.hidden = true;

    Array.from(select.options).forEach((option, index) => {
      const li = document.createElement('li');
      li.className = 'custom-select__option';
      li.setAttribute('role', 'option');
      li.dataset.index = String(index);
      if (option.selected) li.setAttribute('aria-selected', 'true');
      li.innerHTML =
        '<span>' +
        option.textContent.trim() +
        '</span><svg class="custom-select__check" viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 8.5 6.5 12 13 4"/></svg>';
      listbox.appendChild(li);
    });

    trigger.addEventListener('click', () => {
      if (listbox.hidden) openListbox(wrapper, trigger, listbox);
      else closeListbox(wrapper, trigger, listbox);
    });

    listbox.addEventListener('click', (e) => {
      const li = e.target.closest('.custom-select__option');
      if (!li) return;

      select.selectedIndex = Number(li.dataset.index);
      select.dispatchEvent(new Event('change', { bubbles: true }));

      listbox.querySelectorAll('.custom-select__option').forEach((el) => el.removeAttribute('aria-selected'));
      li.setAttribute('aria-selected', 'true');
      trigger.textContent = currentLabel(select);
      closeListbox(wrapper, trigger, listbox);
    });

    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target)) closeListbox(wrapper, trigger, listbox);
    });

    wrapper.appendChild(trigger);
    wrapper.appendChild(listbox);
  }

  function enhanceAll(root) {
    (root || document).querySelectorAll('.select').forEach((wrapper) => {
      if (wrapper.querySelector('select.select__select')) enhance(wrapper);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    enhanceAll();

    let debounceTimer;
    const observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        enhanceAll();
      }, 50);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();